module.exports = [
	{
		"name": "Exterior",
		"repair_items": [
			{
				"name": "Door",
				"svg": "door",
				"description": "The door’s hardware should be in working order. The weather stripping should be present.",
				"repair_credit_list": [
					"Non-functional door",
					"Missing weather stripping",
					"Large holes in door requiring a replacement",
					"Malfunctioning locks and track for sliding glass door",
					"Replacing non-fire rated, or compromised garage entry doors"
				]
			},
			{
				"name": "Garage",
				"svg": "garage",
				"description": "Garage door should be operational and opener should be included with home.",
				"opendoor_list": [
					"Remote control replacement"
				],
				"repair_credit_list": [
					"Non functioning garage door or door equipment (including proper safety reversal)",
					"Large dents or similar cosmetic defects",
					"Broken coil spring"
				]
			},
			{
				"name": "Landscaping",
				"svg": "landscaping",
				"description": "Vegetation around property should not interfere with physical property.",
				"repair_credit_list": [
					"Vegetation causing structural defects to property",
					"Any trees/shrubbery that is touching the home or roof"
				]
			},
			{
				"name": "Irrigation",
				"svg": "irrigation",
				"description": "Property should be free from drainage defects (including drainage path directing to home foundation).",
				"repair_credit_list": [
					"Large drainage defects or holes close to foundation.",
					"High grade (ground covering wood framed wall)."
				]
			},
			{
				"name": "Deck",
				"svg": "deck",
				"description": "Decks should be structurally sound and should have infill spacing so they are safe for children.",
				"repair_credit_list": [
					"Structural deck damage",
					"Missing infill spacing (support column)",
					"Water or termite damage",
					"Anything causing structural integrity issues outside of local code"
				]
			},
			{
				"name": "Fencing",
				"svg": "fencing",
				"description": "Property should be free from drainage defects (including drainage path directing to home foundation).",
				"repair_credit_list": [
					"Large cracks",
					"Wood rot",
					"Termites",
					"Missing planks or blocks",
					"Peeling paint",
					"Missing fence where one is required by local code or HOA"
				]
			},
			{
				"name": "Pool Equipment",
				"svg": "pool",
				"description": "Pool equipment (such as filters, lights, pumps, heathers, and chlorination and cleaning system) should be in working order.",
				"repair_credit_list": [
					"Leaking filter",
					"Leaky connections",
					"Broken lights",
					"Broken or leaking pumps",
					"Broken salt chlorination system",
					"Malfunctioning pool pump"
				]
			},
			{
				"name": "Roofing",
				"svg": "roofing",
				"description": "Roof covering protects the interior of the home from water and other elements. Materials are in good working condition.",
				"repair_credit_list": [
					"All broken or slipped tiles or caps.",
					"Any damage to underlayment or evidence of leaks.",
					"Any missing, wind damaged, or incorrectly installed shingles or nail holes.",
					"Any damage, cracks, bubbles, or blisters in sealant.",
					"Anything more than minor ponding water needs to be repaired"
				]
			},
			{
				"name": "Eaves",
				"svg": "eaves",
				"description": "Eaves, sofits, and fascia should be free from water damage and in good repair.",
				"repair_credit_list": [
					"Water damage or peeling paint."
				]
			},
			{
				"name": "Windows",
				"svg": "windows",
				"description": "Windows should exhibit full structural integrity.",
				"repair_credit_list": [
					"Cracked or broken window",
					"Broken thermal seals",
					"Broken window lock"
				]
			}
		]
	},
	{
		"name": "Interior",
		"repair_items": [
			{
				"name": "Kitchen Appliances",
				"svg": "appliances",
				"description": "All appliances should be in working order and free from leaks.",
				"repair_credit_list": [
					"Malfunctioning appliance"
				]
			},
			{
				"name": "Sinks & Faucets",
				"svg": "sinks",
				"description": "Sinks and faucets should flow and be free from leaks. Overflows should be in working order",
				"opendoor_list": [
					"Dirty sinks and faucets"
				],
				"repair_credit_list": [
					"Leaky or broken faucet",
					"Reversed hot & cold",
					"Malfunctioning overflows"
				]
			},
			{
				"name": "Bathtubs & Showers",
				"svg": "showers",
				"description": "Bathtubs and showers be in working order and should be free from leaks.",
				"repair_credit_list": [
					"Leaky or broken fixtures"
				]
			},
			{
				"name": "Walls & Ceiling",
				"svg": "walls",
				"description": "Walls and ceiling should be structurally sound and free from holes, cracks, and water damage.",
				"opendoor_list": [
					"Patch nail holes"
				],
				"repair_credit_list": [
					"Cracks/holes, water damage, peeling paint"
				]
			},
			{
				"name": "Flooring",
				"svg": "flooring",
				"description": "Flooring may show wear from gentle use, but should be free from obvious defects.",
				"opendoor_list": [
					"Dirty carpeting and flooring"
				],
				"repair_credit_list": [
					"Tears in carpeting",
					"Heavily damaged flooring"
				]
			},
			{
				"name": "Odors",
				"svg": "odors",
				"description": "Home should be free from significant odors such as smoke and pet-related odors.",
				"repair_credit_list": [
					"Replacement of carpet when required to deodorize the home",
					"Replacement of paint when required to deodorize the home"
				]
			}
		]
	},
	{
		"name": "Utilities",
		"repair_items": [
			{
				"name": "Smoke Detectors",
				"svg": "smoke",
				"description": "Smoke and carbon monoxide detectors should be in working order and less than 10 years old.",
				"opendoor_list": [
					"Smoke detector batteries",
					"Replace dated but functioning smoke detectors"
				],
				"repair_credit_list": [
					"Missing or broken smoke detector",
					"Broken carbon monoxide detector (only for homes with gas)"
				]
			},
			{
				"name": "Circuit Breakers",
				"svg": "circuit",
				"description": "Circuit breakers should be in working condition. They should be in rooms as required by code.",
				"opendoor_list": [
					"Add breaker outlets to kitchens, baths, and exteriors",
					"Wiring should be correctly installed."
				]
			},
			{
				"name": "Panels",
				"svg": "panel",
				"description": "Not Zinsco/Sylvania GTE or Federal Pacific brands. These are brands known to have defects and recommended by the governent to be replaced.",
				"repair_credit_list": [
					"Replace any defective brand panels"
				]
			},
			{
				"name": "Overcurrent",
				"svg": "overcurrent",
				"description": "Overcurrent protection should be operational.",
				"repair_credit_list": [
					"Repair double taps or damaged breakers"
				]
			},
			{
				"name": "HVAC",
				"svg": "hvac",
				"description": "Thermostat controls should be in working order. Equipment should be clean and free from leaks.",
				"repair_credit_list": [
					"Broken cooling system",
					"Broken cooling distribution system",
					"Unsealed ducting",
					"Unsealed or broken ducts",
					"HVAC units older than 12 years"
				]
			},
			{
				"name": "Water Heater",
				"svg": "heater",
				"description": "Water heater should be in good working condition, free from leaks, and pipes should be insulated.",
				"repair_credit_list": [
					"Leak or corrosion at supply valve and/or lines"
				]
			}
		]
	},
	{
		"name": "Miscellaneous",
		"repair_items": [
			{
				"name": "Pests",
				"svg": "pests",
				"description": "Home should be free from significant pest infestations (termites, roaches and pigeon activity on roof)",
				"repair_credit_list": [
					"Evidence of persistent pest problem, e.g. termites, rodents"
				]
			},
			{
				"name": "Attic",
				"svg": "attic",
				"description": "Trusses should be structurally sound.",
				"opendoor_list": [
					"Trash in attic"
				],
				"repair_credit_list": [
					"Insulation is sufficient to meet local code requirements",
					"Trusses are in good shape and not cracked or damaged"
				]
			},
			{
				"name": "Foundation",
				"svg": "foundation",
				"description": "Foundation, stemwall & retaining wall must all be structurally sound.",
				"repair_credit_list": [
					"Any implied issue with foundation, e.g. sagging floors, large settling cracks on exterior (1/4 - 1/2 inch or more)",
					"Cracks in interior floors / walls, significant settling, horizontal cracks in foundation, etc."
				]
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/repairs.yml
 ** module id = 3573
 ** module chunks = 3
 **/